var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreloaderList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 78,
    viewBox: "0 0 172 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M170 0.5H22C21.1716 0.5 20.5 1.17157 20.5 2V14C20.5 14.8284 21.1716 15.5 22 15.5H170C170.828 15.5 171.5 14.8284 171.5 14V2C171.5 1.17157 170.828 0.5 170 0.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M149 27.5H22C21.1716 27.5 20.5 28.1716 20.5 29V36C20.5 36.8284 21.1716 37.5 22 37.5H149C149.828 37.5 150.5 36.8284 150.5 36V29C150.5 28.1716 149.828 27.5 149 27.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M133 47.5H22C21.1716 47.5 20.5 48.1716 20.5 49V56C20.5 56.8284 21.1716 57.5 22 57.5H133C133.828 57.5 134.5 56.8284 134.5 56V49C134.5 48.1716 133.828 47.5 133 47.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M141 67.5H22C21.1716 67.5 20.5 68.1716 20.5 69V76C20.5 76.8284 21.1716 77.5 22 77.5H141C141.828 77.5 142.5 76.8284 142.5 76V69C142.5 68.1716 141.828 67.5 141 67.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V14C0.5 14.8284 1.17157 15.5 2 15.5H14C14.8284 15.5 15.5 14.8284 15.5 14V2C15.5 1.17157 14.8284 0.5 14 0.5Z",
    fill: "#D9D9D9",
    stroke: "#DEE2E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreloaderList);
export default __webpack_public_path__ + "static/media/PreloaderList.eaf322fb3733bb6220974374c04078c8.svg";
export { ForwardRef as ReactComponent };